<template>
  <v-dialog
    v-model="modal"
    max-width="500px"
  >
    <v-card class="popup-modal">
      <v-card-title>
        <h1>New Project</h1>
      </v-card-title>
        <v-card-text>
          <v-text-field
            label="Name"
            v-model="projectName"
            class="form-field"
            required
          ></v-text-field>
          <v-select
            label="Organization"
            v-model="selectedOrgId"
            :items="orgs"
            item-value="_id"
            item-text="name"
            class="form-field"
            required
          ></v-select>
          <p v-if="renderFormError" class="form-error">
            Please include an organization and project name.
          </p>
          <v-btn @click="addProject" class="add-project">
            Add Project
          </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AddProjectModal',
  data() {
    return {
      projectName: null,
      selectedOrgId: null,
      renderFormError: false,
    };
  },
  props: [
    'showModal',
  ],
  computed: {
    // Defines getters and setters for showing the modal
    // We dont want vue material controlling our props
    ...mapState({
      orgs: state => state.orgs.data,
    }),
    modal: {
      get() { return this.showModal; },
      set(val) { if (!val) this.$emit('close'); },
    },
  },
  methods: {
    addProject() {
      if (!this.projectName || !this.selectedOrgId) {
        this.renderFormError = true;
      } else {
        this.$store.dispatch('projects/createProject', {
          orgId: this.selectedOrgId,
          projectName: this.projectName,
        });
        this.modal = false;
        this.renderFormError = false;
        this.projectName = null;
        this.selectedOrgId = null;
      }
    },
  },

};
</script>

<style lang="scss">
.popup-modal {
  background-color: white;
  .form-error {
    color: red;
  }
}
.add-project {
  background-color: #17c68d;
  color: white;
  margin-left: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/AddProjectModal.vue